import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ContratoListarRoutingModule } from "./contrato-listar-routing.module";
import { ContratoListarComponent } from "./contrato-listar.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { ConfirmationService } from "primeng/api";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { FormsModule } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { MessagesModule } from "primeng/messages";


@NgModule({
    imports: [
        CommonModule,
        ContratoListarRoutingModule,       
        FormsModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        TooltipModule,
        ConfirmDialogModule,
        FormatPipeModule,
        DropdownModule,
        MessagesModule
    ],
    providers: [ConfirmationService],
    declarations: [ContratoListarComponent]
})
export class ContratoListarModule { }
